import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SliderQuestion } from '@app/core/models/question/slider-question';

@Component({
  selector: 'app-my-income-protection',
  templateUrl: './my-income-protection.component.html',
  styleUrls: ['./my-income-protection.component.css']
})
export class MyIncomeProtectionComponent implements OnInit {
  @Input() data: any;
  @Output() closeModal = new EventEmitter();

  ngOnInit() {
    if (this.data.userAge > 25) {
      this.data.questionaire.forEach(question => {
        if (question instanceof SliderQuestion) {
          if (question.key === 'yearNotNeedSupport') {
            question.value = this.data.userAge;
          }
        }
      });
    }
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-income-protection/my-income-protection.component.ts